import { render, staticRenderFns } from "./Clamping.vue?vue&type=template&id=6a8139a4&scoped=true"
import script from "./Clamping.vue?vue&type=script&lang=js"
export * from "./Clamping.vue?vue&type=script&lang=js"
import style0 from "./Clamping.vue?vue&type=style&index=0&id=6a8139a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8139a4",
  null
  
)

export default component.exports